.aq{overflow:hidden;}